import React, { useState, useEffect } from "react";
import { Link, Navigate, useNavigate } from "react-router-dom";
import axios from "axios";
import { APIURL, TZ } from "../../../Global";
import "bootstrap/dist/css/bootstrap.min.css";
import "./clinics.css"
import DatePicker from 'react-date-picker';
import { useAlert } from 'react-alert';
import Plans from "../SalesManagement/Plans";
function Pricing(props) {
    const alert = useAlert()
    const [master, setMaster] = useState([])
    const [plans, setPlans] = useState({})
    const [common, setCommon] = useState({})
    const [basic, setBasic] = useState([])
    const [pro, setPro] = useState([])
    const [licenses, setLicenses] = useState([])
    const [enterprise, setEnterprice] = useState([])
    const [error,setError]=useState({})
    const [basicEdit, setBasicEdit] = useState(false)
    const [proEdit, setProEdit] = useState(false)
    const [enterpriseEdit, setEnterpriceEdit] = useState(false)
    const [refresh, setRefresh] = useState(false)
    const [refresh1, setRefresh1] = useState(false)
    const [isEdit,setIsEdit]=useState(false)

    useEffect(() => { setRefresh1(!refresh1) }, [props.id])
    useEffect(() => {

        const tokenString = sessionStorage.getItem('usertoken');

        let str = tokenString.replace(/["]+/g, '')
        setBasic([])
        setPro([])
        setEnterprice([])
        axios.get(`${APIURL}/api/v1/staff/hospital-plans/?hospital_id=${props.id}&${TZ}`, {
            headers: {

                "Authorization": 'Token ' + str
            }
        })
            .then(res => {

                if (res.data.status === "success") {
                    setPlans(res.data.details)
                 
                    console.log("plans",res.data.details)
                }


            })
            .catch(err => {

            })
        axios.get(`${APIURL}/api/v1/staff/master-licenses/?${TZ}`, {
            headers: {

                "Authorization": 'Token ' + str
            }
        })
            .then(res => {

                if (res.data.status === "success") {

                    setMaster(res.data.message)

                }


            })
            .catch(err => {

            })


    }, [refresh1]);
    const handleSave = () => {
         document.getElementById("submit-btn").disabled = true;
        const id = props.id;
        const tokenString = sessionStorage.getItem("usertoken");
        const filteredData1 = master.filter(item => {
            return item.version_name === "Basic"
        })
        const filteredData2 = master.filter(item => {
            return item.version_name === "Pro"
        })
        const filteredData3 = master.filter(item => {
            return item.version_name === "Enterprise"
        })
        let str = tokenString.replace(/["]+/g, "");
        let lic = []
        console.log(filteredData1, "filteredData1")
        let dataToUpdate = {}
        if(common.plan_type === "saas")
        dataToUpdate = {
            hospital_id: id,
            free_period: common.free_period!==""&&Number(common.free_period),
            plan_period: "yearly" ,
            amount: 0,
            version: basicEdit ? filteredData1[0].version : proEdit ? filteredData2[0].version : filteredData3[0].version,
            licenses: licenses.map((license) => ({
                license_id: license.id, // Replace license_name with license id
                free_users: Number(license.free_user_count) || 0, // Map to free_users
                extra_user_price: Number(license.extra_user_price) || 0, // Keep the same
            })),
        };
        else{
            dataToUpdate={
                support_period:(common.support_period&&common.support_period!==""&&common.support_period!==null)?Number(common.support_period):0,
                    "hospital_id":id,
                    "free_period":(common.free_period&&common.free_period!==""&&common.free_period!==null)?Number(common.free_period):0,
                    "plan_period":"long_term",
                    "amount":Number(common.amount),
                    "amc_start_date":common.amc_date,
                    "amc_amount":(common.amc&&common.amc!==""&&common.amc!==null)?Number(common.amc):0, 
                    "amc_hours":(common.amchr&&common.amchr!==null&&common.amchr!=="")?Number(common.amchr):0,
                    "version":basicEdit ? filteredData1[0].version : proEdit ? filteredData2[0].version : filteredData3[0].version,
                    
                    "licenses":licenses.map((license) => ({
                        license_id: license.id, // Replace license_name with license id
                        free_users: Number(license.free_user_count) || 0, // Map to free_users
                        extra_user_price: Number(license.extra_user_price) || 0, // Keep the same
                    })),
                   
                 
                
                 
            }
        }
        Object.keys(dataToUpdate).forEach((key) => {
            if (
                dataToUpdate[key] === null ||
                dataToUpdate[key] === undefined ||
                dataToUpdate[key] === ''
            ) {
              delete dataToUpdate[key];
            }
          });
if(common.plan_type !== "saas"&&(!common.amount||common.amount===""||common.amount<0||(common.amc>0&&(!common.amc_date||common.amc_date==="")))){
if(!common.amount||common.amount===""||common.amount<0){
setError((currentstate) => ({
    ...currentstate,
    amount: "Enter amount",
}))}
if(common.amc>0&&(!common.amc_date||common.amc_date==="")){
    setError((currentstate) => ({
        ...currentstate,
        amc_date: "Enter amount",
    }))
}
document.getElementById("submit-btn").disabled = false;
}

else{
        axios
            .post(`${APIURL}/api/v1/staff/hospital-plans/`, dataToUpdate, {
                headers: {
                    Authorization: "Token " + str,
                    "Content-Type": "application/json",
                },
            })

            .then((res) => {

                if (res.data.status === "success") {
                    alert.success(res.data.message)
                    props.handleAdd();
                } else {
                    alert.error(res.data.message);
                    document.getElementById("submit-btn").disabled = false;
                }
            })
            .catch((err) => {
                alert.error("error in submission")
            });
        }
    };
     // Function to compare and get changed fields
  const getChangedFields = (original, updated) => {
    const changed = {};

    for (const key in updated) {
      const originalValue = original[key];
      const updatedValue = updated[key];

      if (Array.isArray(updatedValue)) {
        if (JSON.stringify(originalValue) !== JSON.stringify(updatedValue)) {
          changed[key] = updatedValue;
        }
      } else if (
        typeof updatedValue === 'object' &&
        updatedValue !== null
      ) {
        if (JSON.stringify(originalValue) !== JSON.stringify(updatedValue)) {
          changed[key] = updatedValue;
        }
      } else {
        if (originalValue !== updatedValue) {
          changed[key] = updatedValue;
        }
      }
    }

    return changed;
  };
    const handleUpdate = () => {
        document.getElementById("update-btn").disabled = true;
        const id = props.id;
        const tokenString = sessionStorage.getItem("usertoken");
        const filteredData1 = master.filter(item => {
            return item.version_name === "Basic"
        })
        const filteredData2 = master.filter(item => {
            return item.version_name === "Pro"
        })
        const filteredData3 = master.filter(item => {
            return item.version_name === "Enterprise"
        })
        let str = tokenString.replace(/["]+/g, "");
        let mdata = plans.version==="Basic"?filteredData1:plans.version==="Pro"?filteredData2:filteredData3
        
       
        let dataToUpdate = {}
        let dataToUpdate1 = {}
        if(common.plan_type === "saas")
        dataToUpdate = {
            hospital_id: id,
            free_period: Number(common.free_period),
            plan_period: "yearly" ,
            licenses: licenses.map((license) => {
               
            
                const matchedLicense = mdata[0]?.licenses.find(
                  (l) => l.license_name === license.license_name
                );
                
                return {
                  license_id: matchedLicense?.id || "",
                  free_users: Number(license.free_user_count?license.free_user_count:license.free_users) || 0,
                  extra_user_price: Number(license.extra_user_price) || 0.0,
                };
              }),
            };
           
        
        else{
            dataToUpdate = {
                 support_period: Number(common.support_period),
                hospital_id: id,
                free_period: Number(common.free_period),
                amount: Number(common.amount),
                amc_start_date: common.amc_date,
                amc_amount: Number(common.amc),
                amc_hours: Number(common.amchr),
                licenses: licenses.map((license) => {
                  
                  const matchedLicense = mdata[0]?.licenses.find(
                    (l) => l.license_name === license.license_name
                  );
              
                 
                  return {
                    license_id: matchedLicense?.id || "",
                    free_users: Number(license.free_user_count?license.free_user_count:license.free_users) || 0,
                    extra_user_price: Number(license.extra_user_price) || 0.0,
                  };
                }),
              };
        }
        const updatedFields = getChangedFields(plans, dataToUpdate);
        dataToUpdate1=updatedFields
        console.log(dataToUpdate1)
if(common.plan_type !== "saas"&&(!common.amount||common.amount===""||common.amount<0||(common.amc>0&&(!common.amc_date||common.amc_date==="")))){
    if(!common.amount||common.amount===""||common.amount<0){
        setError((currentstate) => ({
            ...currentstate,
            amount: "Enter amount",
        }))}
if(common.amc>0&&(!common.amc_date||common.amc_date==="")){
    setError((currentstate) => ({
        ...currentstate,
        amc_date: "Enter amount",
    }))
}
document.getElementById("update-btn").disabled = false;
}
else{
        axios
            .put(`${APIURL}/api/v1/staff/hospital-plans/`, dataToUpdate1, {
                headers: {
                    Authorization: "Token " + str,
                    "Content-Type": "application/json",
                },
            })

            .then((res) => {

                if (res.data.status === "success") {
                    alert.success(res.data.message)
                    props.handleAdd();
                } else {
                    alert.error(res.data.message);
                    document.getElementById("update-btn").disabled = true;
                }
            })
            .catch((err) => {
                alert.error("error in submission")
            });
        }
    };
    useEffect(() => {
        if (plans.version) {
            const transformedLicenses = plans.licenses.map((license) => ({
                ...license,
                free_user_count: license.free_users,
                free_users: undefined, // Optional: remove the original key
              }));
              
              setLicenses(transformedLicenses); 
        }
        else {
            basicEdit ? setLicenses(basic) : proEdit ? setLicenses(pro) : setLicenses(enterprise)
        }
    }, [proEdit, basicEdit, enterpriseEdit])

    useEffect(() => {
        if (plans.version) {
            if (plans.version === "Basic") {
                setBasic(plans.licenses)
               
                const transformedLicenses = plans.licenses.map((license) => ({
                    ...license,
                    free_user_count: license.free_users,
                    free_users: undefined, // Optional: remove the original key
                  }));
                  
                  setLicenses(transformedLicenses); // assuming setLicenses is your useState setter
            }
            else if (plans.version === "Pro") {
                setPro(plans.licenses)
                const transformedLicenses = plans.licenses.map((license) => ({
                    ...license,
                    free_user_count: license.free_users,
                    free_users: undefined, // Optional: remove the original key
                  }));
                  
                  setLicenses(transformedLicenses); 
            }
            else if (plans.version === "Enterprise") {
                setEnterprice(plans.licenses)
                const transformedLicenses = plans.licenses.map((license) => ({
                    ...license,
                    free_user_count: license.free_users,
                    free_users: undefined, // Optional: remove the original key
                  }));
                  
                  setLicenses(transformedLicenses); 

            }

            setCommon({ free_period: plans.free_period,
                 plan_type: plans.plan_type,
                amc_date:plans.amc_start_date,
                amc:plans.amc_amount,
                amc_renewed_date :plans.amc_renewed_date,amount:plans.amount,
                amchr:plans.amc_hours,
                support_period:plans.support_period,
                date:plans.amc_start_date===null?"":new Date(plans.amc_start_date)
            })
            
        }
        else {
            if (master.length > 0) {
                const filteredData1 = master.filter(item => {
                    return item.version_name === 'Basic'
                })
                const filteredData2 = master.filter(item => {
                    return item.version_name === 'Pro'
                })
                const filteredData3 = master.filter(item => {
                    return item.version_name === 'Enterprise'
                })
                console.log(filteredData1, "filteredData1")
                setBasic(filteredData1[0].licenses)
                setPro(filteredData2[0].licenses)
                setEnterprice(filteredData3[0].licenses)
                setCommon({ free_period: 0, plan_type: "saas" })
            }
        }
    }, [plans, master, refresh])
    const displayLicense = (i, item, edit) => {
console.log(licenses,"lic2")

        return (
            <div className="col-12 col-sm-6 col-md-6 col-lg-6" style={{ padding: "1%" }}>
                <div style={{ border: "1px solid gray", borderRadius: "5px", backgroundColor: "#cbdadb", padding: "1%" }}>
                    <div className="d-flex justify-content-between">
                        <b>{item?.license_name || "N/A"}</b>
                        {edit||isEdit ? (
                            <>
                                RS
                                <input
                                    className="clinc_input"
                                    type="number"
                                    placeholder=""
                                    value={licenses?.[i]?.extra_user_price}
                                    style={{ width: "20%" }}
                                    onChange={(e) => {
                                        const newValue = (e.target.value<0||e.target.value==="")?"":e.target.value;
                                        setLicenses((currentState) =>
                                            currentState.map((item, index) =>
                                                index === i ? { ...item, extra_user_price: newValue } : item
                                            )
                                        );
                                    }}
                                />
                                /-
                            </>
                        ) : (
                            <>&nbsp;<b>RS {item?.extra_user_price || 0}/-</b></>
                        )}
                    </div>

                    <div style={{ backgroundColor: "white", padding: "1%" }}>
                        <div className="row">
                            <small className="col-7">Free user count</small>
                            {edit||isEdit ? (
                                <input
                                    className="clinc_input"
                                    type="number"
                                    placeholder=""
                                    value={licenses?.[i]?.free_user_count }
                                    style={{ width: "20%" }}
                                    onChange={(e) => {
                                        const newValue = (e.target.value<0||e.target.value==="")?"":e.target.value;
                                        setLicenses((currentState) =>
                                            currentState.map((item, index) =>
                                                index === i ? { ...item, free_user_count: newValue } : item
                                            )
                                        );
                                    }}
                                />
                            ) : (
                                <b className="col-4">
                                    {item?.free_user_count || item?.free_users || 0}
                                </b>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        );
    };
    const handleAmc = date => {
        
        setCommon((currentstate) => ({
            ...currentstate,
            amc_date:date===null||date===""?"": date.toLocaleDateString('en-CA'),
            date:date
        }))
        setError((currentstate) => ({
            ...currentstate,
            amc_date: "",
        }))
    }

    return (<div className="row">

        <div className={ "col-9"}>
            <div className="" style={{ padding: "1%", minHeight: "71vh" }}>

                {(plans.version && plans.version === "Basic") || (!plans.version) ? <div className="" style={{ border: "1px solid gray", borderRadius: "5px", backgroundColor: "#FDF5EE", padding: "3%", marginBottom: "1%" }}>
                    <h6 className="row">
                        <div className="col-2"><b >BASIC</b></div>
                        <div className="col-8 row">
                            {plans.version &&!isEdit&& <> <div className="col-6">{common.plan_type!=="full_time"&&<><span className="text-left ">Free period</span>
                                <>&nbsp;<b>{common.free_period}</b>&nbsp;</>days</>}</div>
                                <div className="col-6"> <p className="text-left  ">Plan type:
                                    <>&nbsp;<b className="">{plans.plan_type ? plans.plan_type.replace(/_/g, ' ') : "saas"}</b>&nbsp;</></p>
                                </div>
                            </>}


                        </div>
                        {!plans.version && <div className="col-2">
                            <button disabled={plans.version} onClick={(e) => { setBasicEdit(!basicEdit); setProEdit(false); setEnterpriceEdit(false); setRefresh(!refresh) }
                            } style={{ backgroundColor: basicEdit && "red", width: "100%", cursor: plans.version ? "not-allowed" : "pointer" }} className="clinic_button">{basicEdit ? "Cancel" : "Select"}</button>
                        </div>}
                        {/* <div className="col-2">
                     <button disabled={!basicEdit}onClick={(e) => { handleSave() }
                         } style={{ backgroundColor: "#55479F",width:"100%" }} className="clinic_button">Add license</button>
                     </div> */}
                    </h6>
                    <div className="container-fluid">
                        <div className="row">
                            {basic.length > 0 && basic.map((item, index) => {
                                return (
                                    displayLicense(index, item, basicEdit)
                                )
                            })}

                        </div>
                    </div>

                </div> : ""}
                {(plans.version && plans.version === "Pro") || (!plans.version) ? <div className="" style={{ border: "1px solid gray", borderRadius: "5px", backgroundColor: "#F9FEF8", padding: "3%", marginBottom: "1%" }}>
                    <h6 className="row">
                        <div className="col-2"><b >Pro</b></div>
                        <div className="col-8 row">
                            {plans.version && <> <div className="col-6">{common.plan_type!=="full_time"&&<><span className="text-left ">Free period</span>
                                <>&nbsp;<b>{common.free_period}</b>&nbsp;</>days</>}</div>
                                <div className="col-6"> <p className="text-left  ">Plan type:
                                    <>&nbsp;<b className="">{plans.plan_type ? plans.plan_type.replace(/_/g, ' ') : "SaaS"}</b>&nbsp;</></p>
                                </div>
                            </>}


                        </div>
                        <div className="col-2">
                            <button onClick={(e) => { (setProEdit(!proEdit)); setBasicEdit(false); setEnterpriceEdit(false); setRefresh(!refresh) }
                            } style={{ backgroundColor: proEdit && "red", width: "100%" }} className="clinic_button">{proEdit ? "Cancel" : "Select"}</button>
                        </div>
                        {/* <div className="col-2">
                         <button disabled={!proEdit}onClick={(e) => {  handleSave() }
                         } style={{ backgroundColor: "#55479F",width:"100%" }} className="clinic_button">Add license</button>
                     </div> */}
                    </h6>
                    <div className="container-fluid">
                        <div className="row">
                            {pro.map((item, index) => {
                                return (
                                    displayLicense(index, item, proEdit)
                                )
                            })}

                        </div>
                    </div>
                </div> : ""}
                {(plans.version && plans.version === "Enterprise") || (!plans.version) ? <div className="" style={{ border: "1px solid gray", borderRadius: "5px", backgroundColor: "#FAF1F3", padding: "3%", marginBottom: "1%" }}>
                    <h6 className="row">
                        <div className="col-2"><b >Enterprise</b></div>
                        <div className="col-8 row">
                            {plans.version && <> <div className="col-6">{common.plan_type!=="full_time"&&<><span className="text-left ">Free period</span>
                                <>&nbsp;<b>{common.free_period}</b>&nbsp;</>days</>}</div>
                                <div className="col-6"> <p className="text-left  ">Plan type:
                                    <>&nbsp;<b className="">{plans.plan_type&&plans.plan_type.replace(/_/g, ' ')}</b>&nbsp;</></p>
                                </div>
                            </>}


                        </div>
                        <div className="col-2">
                            <button onClick={(e) => { (setEnterpriceEdit(!enterpriseEdit)); setBasicEdit(false); setProEdit(false); setRefresh(!refresh) }
                            } style={{ backgroundColor: enterpriseEdit && "red", width: "100%" }} className="clinic_button">{enterpriseEdit ? "Cancel" : "Select"}</button>
                        </div>
                      
                    </h6>
                    <div className="container-fluid">
                        <div className="row">
                            {enterprise.map((item, index) => {
                                return (
                                    displayLicense(index, item, enterpriseEdit)
                                )
                            })}

                        </div>
                    </div>
                </div> : ""}


            </div>
        </div>
        {!plans.version||isEdit ? 
        <div className="col-3" style={{ padding: "0.5%" }}>
            <div className="det-div " style={{ padding: "2%" }}>
           {isEdit && <button onClick={(e) => {  setIsEdit(false);setRefresh1(!refresh1) } }
                 style={{ backgroundColor: "#55479F", width: "20%",float:"right" }} className="clinic_button">{<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" d="m8.4 16.308l3.6-3.6l3.6 3.6l.708-.708l-3.6-3.6l3.6-3.6l-.708-.708l-3.6 3.6l-3.6-3.6l-.708.708l3.6 3.6l-3.6 3.6zM12.003 21q-1.866 0-3.51-.708q-1.643-.709-2.859-1.924t-1.925-2.856T3 12.003t.709-3.51Q4.417 6.85 5.63 5.634t2.857-1.925T11.997 3t3.51.709q1.643.708 2.859 1.922t1.925 2.857t.709 3.509t-.708 3.51t-1.924 2.859t-2.856 1.925t-3.509.709M12 20q3.35 0 5.675-2.325T20 12t-2.325-5.675T12 4T6.325 6.325T4 12t2.325 5.675T12 20m0-8"/></svg>}</button>}
                <div className="">{!isEdit?<div style={{ marginTop: "3%" }}>
                    <span className="">Plan type:</span>

                    <select
                        name='allergytype'
                        className="clinc_input"
                        style={{ padding: "auto", marginTop: "0.5%", width: "100%" }}
                        value={common.plan_type}
                        onChange={(e) => {
                            setCommon((currentstate) => ({
                                ...currentstate,
                                plan_type: e.target.value,
                            }))
                        }}>
                        <option value="" selected hidden  >Select type</option>
                        <option value="saas" >SaaS mode</option>
                        <option value="full_pay" >Full pay mode</option>


                    </select> </div>:<div style={{ marginTop: "3%" }}>
                    <span className=""><b>Plan type</b></span><br/>
                    <span>{common.plan_type&&common.plan_type.replace(/_/g, ' ')}</span>
                        </div>}
                    {common.plan_type === "saas" ?
                        <div style={{ paddingTop: "3%" }}>
                            <span className="">Free period</span><br />
                            <input
                                className="clinc_input"
                                disabled={isEdit}
                                type="text"
                                maxLength="100"
                                placeholder="in days"
                                value={common.free_period}
                                style={{ width: "100%",cursor:isEdit&&"not-allowed" }}
                                onChange={(e) => setCommon((currentstate) => ({
                                    ...currentstate,
                                    free_period: e.target.value>0?e.target.value:"",
                                })
                                )}
                            /></div> :
                        <>
                        <div style={{ paddingTop: "3%" }}>
                            <span className="">Support period</span><br />
                            <input
                                className="clinc_input"
                                type="text"
                                maxLength="100"
                                placeholder="in days"
                                value={common.support_period}
                                style={{ width: "100%" }}
                                onChange={(e) => setCommon((currentstate) => ({
                                    ...currentstate,
                                    support_period: e.target.value>0?e.target.value:"",
                                })
                                )}
                            /></div>
                            <div style={{ paddingTop: "3%" }}></div>
                            <span className="">Amount</span><br />
                            <input
                               className={`${error.amount ? 'error-border' : 'clinc_input'}`}
                                type="number"
                                maxLength="100"
                                placeholder=""
                                value={common.amount}
                                style={{ width: "100%" }}
                                onChange={(e) => {setCommon((currentstate) => ({
                                    ...currentstate,
                                    amount: e.target.value>0?e.target.value:"",
                                    // amc:"",
                                    // amcper:""
                                })
                                );setError((currentstate) => ({
                                    ...currentstate,
                                    amount: "",
                                }))}}
                            />
                            <div style={{ paddingTop: "3%" }}></div>
                            <span className="">AMC</span><br />
                            <div style={{display:"flex"}}>
                            <input
                                className="clinc_input"
                                type="number"
                                disabled={!common.amount||common.amount<1}
                                maxLength="100"
                                placeholder="in amount"
                                value={common.amc}
                                style={{ width: "48%" }}
                                onChange={(e) => setCommon((currentstate) => ({
                                    ...currentstate,
                                    amc:e.target.value>0?e.target.value:"",
                                    amcper:e.target.value===""?"":e.target.value>0?(e.target.value*100)/common.amount:""
                                })
                                )}
                            /> OR <input
                            className="clinc_input"
                            type="number"
                            disabled={!common.amount||common.amount<1}
                            maxLength="100"
                            placeholder="in %"
                            value={common.amcper}
                            style={{ width: "48%" }}
                            onChange={(e) => setCommon((currentstate) => ({
                                ...currentstate,
                                amcper:(e.target.value===""||e.target.value<0)?"": e.target.value,
                                amc:(e.target.value===""||e.target.value<0)?"":common.amount*(e.target.value/100)
                            })
                            )}
                        /></div>
                        <div style={{ paddingTop: "3%" }}></div>
                            <span className="">AMC hours </span><br />
                            <input
                            disabled={!common.amc||common.amc<1}
                                className="clinc_input"
                                type="number"
                                maxLength="100"
                                placeholder="in hr"
                                value={common.amchr}
                                style={{ width: "100%" }}
                                onChange={(e) => setCommon((currentstate) => ({
                                    ...currentstate,
                                    amchr: e.target.value>0?e.target.value:"",
                                })
                                )}
                            />
                            <div style={{ paddingTop: "3%" }}></div>
                            <span className="">AMC starting on</span><br />
                            <DatePicker
                                onChange={date => { handleAmc(date) }}
                                className={`${error.amc_date ? 'clinc_input_error' : 'clinc_input'}`}
                                style={{ width: "100%"}}
                                minDate={new Date()}
                                value={common.date> new Date().setHours(0, 0, 0, 0)?common.date:""}

                            />{new Date(common.date) < new Date().setHours(0, 0, 0, 0) && (
                                <div style={{ fontSize: '12px' }}>
                                  {common.amc_date&&common.amc_date.slice(0,10)}
                                </div>
                              )}
                            <br/>
                        
                        </>}

                    <br />



                </div>
                {isEdit ? <div className="">
                <button id="update-btn" onClick={(e) => {   handleUpdate() }
                } style={{ backgroundColor: "#55479F", width: "100%" }} className="clinic_button">Update</button>
            </div>:<div className="">
                <button id="submit-btn" onClick={(e) => { if (!basicEdit && !proEdit && !enterpriseEdit&&!isEdit) { alert.error("Choose any plan!!") } else { handleSave() } }
                } style={{ backgroundColor: "#55479F", width: "100%" }} className="clinic_button">Submit</button>
            </div>
            
            }
 <span style={{fontSize:"11px",color:"orange",margin:"auto"}}>*Payment links will not be sent for liabilities above 5 lakhs .Clients can complete the transaction using bank transfer method..</span>
            </div>
        </div>:
        <div className="col-3" style={{ padding: "0.5%" }}>
        <div className="det-div " style={{ padding: "2%" }}>
         <div className="">
                <button onClick={(e) => {  setIsEdit(true);console.log(licenses,"lic1") } }
                 style={{ backgroundColor: "#55479F", width: "20%",float:"right" }} className="clinic_button"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><g class="edit-outline"><g fill="currentColor" fill-rule="evenodd" class="Vector" clip-rule="evenodd"><path d="M2 6.857A4.857 4.857 0 0 1 6.857 2H12a1 1 0 1 1 0 2H6.857A2.857 2.857 0 0 0 4 6.857v10.286A2.857 2.857 0 0 0 6.857 20h10.286A2.857 2.857 0 0 0 20 17.143V12a1 1 0 1 1 2 0v5.143A4.857 4.857 0 0 1 17.143 22H6.857A4.857 4.857 0 0 1 2 17.143z"/><path d="m15.137 13.219l-2.205 1.33l-1.033-1.713l2.205-1.33l.003-.002a1.2 1.2 0 0 0 .232-.182l5.01-5.036a3 3 0 0 0 .145-.157c.331-.386.821-1.15.228-1.746c-.501-.504-1.219-.028-1.684.381a6 6 0 0 0-.36.345l-.034.034l-4.94 4.965a1.2 1.2 0 0 0-.27.41l-.824 2.073a.2.2 0 0 0 .29.245l1.032 1.713c-1.805 1.088-3.96-.74-3.18-2.698l.825-2.072a3.2 3.2 0 0 1 .71-1.081l4.939-4.966l.029-.029c.147-.15.641-.656 1.24-1.02c.327-.197.849-.458 1.494-.508c.74-.059 1.53.174 2.15.797a2.9 2.9 0 0 1 .845 1.75a3.15 3.15 0 0 1-.23 1.517c-.29.717-.774 1.244-.987 1.457l-5.01 5.036q-.28.281-.62.487m4.453-7.126s-.004.003-.013.006z"/></g></g></svg></button>
            </div>
            <div className=""><div style={{ marginTop: "3%" }}>

                <span className=""><b>Plan type</b></span><br/>
<span>{common.plan_type&&common.plan_type.replace(/_/g, ' ')}</span>
               </div>
                {common.plan_type === "saas" ?
                    <div style={{ paddingTop: "3%" }}>
                        <span className=""><b>Free period</b></span><br />
                        <span className="">{common.free_period}</span>
                      </div> :
                    <>
                    <div style={{ paddingTop: "3%" }}></div>
                        <span className=""><b>Support period</b></span><br />
                        <span className=""> {common.support_period} Days</span>

                        <div style={{ paddingTop: "3%" }}></div>
                        <span className=""><b>Amount</b></span><br />
                        <span className="">RS {common.amount}/-</span>
                       
                        <div style={{ paddingTop: "3%" }}></div>
                        <span className=""><b>AMC</b></span><br />
                       
                        <span>RS {common.amc&&Number(common.amc).toFixed(2)+"/-"}</span>
                   
                    <div style={{ paddingTop: "3%" }}></div>
                        <span className=""><b>AMC hours</b> </span><br />
                        <span className="">{common.amchr}hr </span>
                        
                        <div style={{ paddingTop: "3%" }}></div>
                        <span className=""><b>AMC starting on</b></span><br />
                        <span>{common.amc_date&&common.amc_date.slice(0,10)}</span>

                       {common.amc_renewed_date!==null&&<> <div style={{ paddingTop: "3%" }}></div>
                        <span className=""><b>AMC renewed date</b></span><br />
                        <span>{common.amc_renewed_date&&common.amc_renewed_date.slice(0,10)}</span></>}
                        <br/>
                    </>}

                <br />



            </div>
            

        </div>
    </div>
        }


    </div>
    );
}
export default Pricing;
